import { render } from "./RadioList.vue?vue&type=template&id=227546aa"
import script from "./RadioList.vue?vue&type=script&lang=js"
export * from "./RadioList.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__